import type { FaireProductEntity } from "../../entity_types/product";

export const p_nrg5hxcuy3: FaireProductEntity = {
  token: "p_nrg5hxcuy3",
  type: "product",
  name: "Chaplin 18K Gold Non-Tarnish Rhinestone Letter Bracelet",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/69f27eb0fe9d54da05d930cfed20dd723dc9b64f53995bc68d2e0009973615d7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bd43c1c68a14adf26bd79f6e5f9d9758c423b56d566cf6c32b48d7e0dba21e5a.jpeg",
    "https://cdn.faire.com/fastly/4bfd05d039b0a79d1954106b15c9fde0a5a5a69ad72d76df81d198d0b119d63c.jpeg",
    "https://cdn.faire.com/fastly/80a35c43b8c5588330751c953a7c1346568ef00ec6edc1b482ea2f60642ecd43.jpeg",
    "https://cdn.faire.com/fastly/037e612dd51e6a99801008cf0986b32c9eb15d253945b6322b04b795be80a5d6.jpeg",
  ],
  priceDollars: 6.35,
  description:
    "18K Gold Non-Tarnish Rhinestone Letter Bracelet\n18K Gold Plating\nStainless Steel\nPendant Size (inch): 0.26-0.3\nChain Length (inch): 6.29\nExtension Length (inch): 1.96\n \n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:33.687Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
